// components/home/AuthPromptBox.jsx
// CSS is now consolidated in home.css - no separate import needed
import React from 'react';
import { Link } from 'react-router-dom';
import './authPromptBox.css';

const AuthPromptBox = () => {
  return (
    <div className="auth-prompt-box">
      <div className="auth-prompt-content">
        <div className="auth-prompt-header">
          <i className="uil uil-user-circle"></i>
          <h3>Join SpinoSoftBits</h3>
        </div>
        
        <p className="auth-prompt-description">
          Get instant access to your personal dashboard where you can:
        </p>
        
        <ul className="auth-prompt-features">
          <li>
            <i className="bx bx-check-circle"></i>
            <span>Track project progress in real-time</span>
          </li>
          <li>
            <i className="bx bx-check-circle"></i>
            <span>Manage invoices & payments</span>
          </li>
          <li>
            <i className="bx bx-check-circle"></i>
            <span>Access project files & resources</span>
          </li>
          <li>
            <i className="bx bx-check-circle"></i>
            <span>Direct messaging with your developer</span>
          </li>
        </ul>
        
        <div className="auth-prompt-buttons">
          <Link to="/register" className="auth-prompt-register">
            <i className="uil uil-user-plus"></i>
            Register Now
          </Link>
          <Link to="/login" className="auth-prompt-login">
            Already a member? Sign In
          </Link>
        </div>
        
        <p className="auth-prompt-note">
          <i className="bx bx-shield-quarter"></i>
          Free to join • No credit card required
        </p>
      </div>
    </div>
  );
};

export default AuthPromptBox;